import React from 'react';
import PropTypes from 'prop-types';
import { leagueDivisionFromName } from '../../../../service/leagueTable';
import { StyledLegend, StyledLegendItem, StyledSwatch } from './styled';

const ITEMS = {
  1: [
    { color: '#fdca40', label: 'Champion' },
    { color: '#e94235', label: 'Relegation' },
  ],
  2: [
    { color: '#00b56a', label: 'Promotion' },
    { color: '#e94235', label: 'Relegation' },
  ],
  3: [{ color: '#00b56a', label: 'Promotion' }],
};

const LeagueLegend = ({ leagueName }) => {
  const items = ITEMS[leagueDivisionFromName(leagueName)];
  if (!items) return null;
  return (
    <StyledLegend>
      {items.map((item) => (
        <StyledLegendItem key={item.label}>
          <StyledSwatch $color={item.color} />
          {item.label}
        </StyledLegendItem>
      ))}
    </StyledLegend>
  );
};

LeagueLegend.propTypes = {
  leagueName: PropTypes.string,
};

LeagueLegend.defaultProps = {
  leagueName: null,
};

export default LeagueLegend;
